import { render, staticRenderFns } from "./AccountDeletionRequests.vue?vue&type=template&id=47781195"
import script from "./AccountDeletionRequests.vue?vue&type=script&lang=js"
export * from "./AccountDeletionRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports